import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import Select from 'react-select'
import './Habitacion.css';
import useColumnsHabitacion from "../../hooks/useColumnsHabitacion";
import { AuthenticationService } from '../../services/authentication.service';
import * as Constants from '../../constants';
import PopUpHabitacion from './NuevaHabitacion';
import HabitacionService from '../../services/habitacion.service';
import Table from './TableHabitacion';
import { MdOutlineBedroomChild } from "react-icons/md";
import { MdOutlineFileUpload } from "react-icons/md";
import { MdCancel } from "react-icons/md";
import { useEstablishment } from '../../Context/EstablishmentContext';
import toast, { Toaster } from 'react-hot-toast';
import PopUpConfirmCargarFichero from './CargarFichero';
import { IoSearch } from "react-icons/io5";
import { FaFilter } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa";
import PopUpValidaHabitacion from './ValidarHabitacion';

const Habitacion = () => {
	const [seen, setSeen] = useState(false);
	const [seenConfirmCargarFichero, setSeenConfirmCargarFichero] = useState(false);
	const [seenValidaPopup, setSeenValidaPopup] = useState(false);
	
	const [t] = useTranslation("global");
	const authenticationService = new AuthenticationService();
	const { establecimiento } = useEstablishment();

	const [filtroActivo, setFiltroActivo] = useState(1);
	const [filtroTerminada, setFiltroTerminada] = useState(null);
	const [listaEstadosHabitacion, setListaEstadosHabitacion] = useState([]);
	const [selectedEstado, setSelectedEstado] = useState('');
	const [selectedHabitacion, setSelectedHabitacion] = useState(null);
	const [filtroEdificio, setFiltroEdificio] = useState('');
	const [filtroPlanta, setFiltroPlanta] = useState('');
	const [filtroCombinarCamas, setFiltroCombinarCamas] = useState(null);
	
	const [selectedFile, setSelectedFile] = useState(null);
	const fileReference = useRef();
	const toastFileExtensionError = () => toast.error(t('app.error.fileExtensionError'));
	
	const navigate = useNavigate();

	const [listaHabitaciones, setListHabitaciones] = useState([]);

	const userRol = authenticationService.getAuthenticationSession().user.idTipo;
	const tipoEmpleado = authenticationService.getAuthenticationSession().user.tipoEmpleado;//obtiene el tipo de trabajador
	const userEstablecimiento = authenticationService.getAuthenticationSession().user.establecimiento;
	
	const toastGenericErrorLogin = () => toast.error(t('app.error.login.generic'));
	
	useEffect(() => {
		const authentication = authenticationService.getAuthenticationSession().user.idTipo;

		if (authentication === null) {
			navigate(Constants.ROUTE_ROOT);
		} else {
			if (userRol != Constants.ROLE_USUARIO_TRABAJADOR) {
			obtenerListaHabitaciones();
			obtenerEstadoHabitaciones();
		} else {
			obtenerEstadoHabitaciones();
			obtenerListaHabitacionesByParams(filtroActivo, selectedEstado, filtroEdificio, filtroPlanta,filtroTerminada)
			
		}
			
		}
	}, [navigate, establecimiento]);


	function togglePop() {

		if (selectedHabitacion != null) {
			setSelectedHabitacion(null);
		}

		setSeen(!seen);
	}
	
	function togglePopConfirmCargarFichero() {

		setSeenConfirmCargarFichero(!seenConfirmCargarFichero);
	}

	function guardarSelectedHabitacion(habitacion) {
		setSelectedHabitacion(habitacion);
	}

	const obtenerListaHabitaciones = async () => {
		if (userRol != Constants.ROLE_USUARIO_TRABAJADOR) {
			await HabitacionService.getHabitaciones(establecimiento.id)
				.then(response => response.json())
				.then(data => setListHabitaciones(data));
		} else {
			await HabitacionService.getHabitaciones(userEstablecimiento)
				.then(response => response.json())
				.then(data => setListHabitaciones(data));
		}

	}
	

	const obtenerEstadoHabitaciones = async () => {
		await HabitacionService.getEstadosHabitacion()
			.then(response => response.json())
			.then(data => setListaEstadosHabitacion(data));

	}

	const obtenerListaHabitacionesByParams = async (filtroActivo, selectedEstado, filtroEdificio, filtroPlanta, filtroTerminada, filtroCombinarCamas) => {
		if (userRol != Constants.ROLE_USUARIO_TRABAJADOR) {
			await HabitacionService.getHabitacionesByParams(establecimiento.id, filtroActivo, selectedEstado, filtroEdificio, filtroPlanta,filtroTerminada,filtroCombinarCamas)
				.then(response => response.json())
				.then(data => setListHabitaciones(data));
		} else {
			await HabitacionService.getHabitacionesByParams(userEstablecimiento, filtroActivo, selectedEstado, filtroEdificio, filtroPlanta,filtroTerminada,filtroCombinarCamas)
				.then(response => response.json())
				.then(data => setListHabitaciones(data));
		}

	}

	const optionsActivo = [
		{ value: 1, label: t('app.label.si') },
		{ value: 0, label: t('app.label.no') }
	];
	
	const optionsTerminada = [
		{ value: null, label: t('app.poup.label.sinseleccion') },
		{ value: 2, label: t('app.habitacion.validada') },
		{ value: 1, label: t('app.habitacion.terminada') },
		{ value: 0, label: t('app.label.no') },
	];
	
	const optionsCombinarCamas = [
		{ value: null, label: t('app.label.todas') },
		{ value: 1, label: t('app.habitacion.combinadas') },
		{ value: 0, label: t('app.habitacion.sinCombinar') }
	];

	const onChangeFiltroActivo = (ev) => {
		setFiltroActivo(ev.value);
		obtenerListaHabitacionesByParams(ev.value, selectedEstado, filtroEdificio, filtroPlanta,filtroTerminada,filtroCombinarCamas);
	}
	
	const onChangeFiltroTerminada = (ev) => {
		setFiltroTerminada(ev.value);
		obtenerListaHabitacionesByParams(filtroActivo, selectedEstado, filtroEdificio, filtroPlanta,ev.value,filtroCombinarCamas);
	}

	const onChangeFiltroEstadoHabitaciones = (ev) => {
		setSelectedEstado(ev.id)
		obtenerListaHabitacionesByParams(filtroActivo, ev.id, filtroEdificio, filtroPlanta,filtroTerminada,filtroCombinarCamas);

	}
	
	const onChangeFiltroEdificio = (ev) => {
		setFiltroEdificio(ev.target.value)
		obtenerListaHabitacionesByParams(filtroActivo, selectedEstado, ev.target.value, filtroPlanta,filtroTerminada,filtroCombinarCamas);
	}

	const onChangeFiltroPlanta = (ev) => {
		setFiltroPlanta(ev.target.value)
		obtenerListaHabitacionesByParams(filtroActivo, selectedEstado, filtroEdificio, ev.target.value,filtroTerminada,filtroCombinarCamas);
	}
	
	const onChangeFiltroCombinarCamas = (ev) => {
		setFiltroCombinarCamas(ev.value);
		obtenerListaHabitacionesByParams(filtroActivo, selectedEstado, filtroEdificio, filtroPlanta, filtroTerminada, ev.value);
	}

	const limpiarFiltros = () => {
		setFiltroActivo(1);
		setSelectedEstado('');
		setFiltroEdificio('');
		setFiltroPlanta('');
		setFiltroTerminada(null);
		obtenerListaHabitaciones();
		setFiltroCombinarCamas(null);
	}
	
	const onChangeFile = (event) => {
		setSelectedFile(event.target.files[0]);
  	};
  	
  	const onClickFile = () => {
    	fileReference.current.click();
  	};
  	
  	const onClickUpload = () => {
    	if (selectedFile) {
			
			const allowedExtensions = ['xls', 'xlsx'];
			const fileExtension = selectedFile.name.split('.').pop().toLowerCase();
			
			if (!allowedExtensions.includes(fileExtension)) {
		        toastFileExtensionError();
		    } else {
				setSeenConfirmCargarFichero(true);				
			}
	    }
  	};
  	
  	const onClickCancelUpload = () => {
    	setSelectedFile(null);
  	};
  	
  	const colorFiltros = {
	  menuList: styles => ({
	    ...styles,
	    background: '#FAE6F1',
	  }),
	  option: (styles, { isFocused, isSelected }) => ({
	    ...styles,
	    background: isSelected
	        ? '#91005F'
	        : '#FAE6F1',
	    zIndex: 1,
	    "&:hover": {
			background: 'rgba(145, 0, 95, 0.2)',
			color: '#000'
		},
	  }),
	  menu: base => ({
	    ...base,
	    zIndex: 100
	  }),
	}
	
	// Para mostrar el color de fondo de la opción elegida en la lista de Estado de habitación
	const getOptionValueEstadoHabitacion = option => option.id;
	
	const validaHabitacion = async () => {
		await HabitacionService.validaHabitacion(selectedHabitacion.id, authenticationService.getAuthenticationSession().user.id)
			.then((response) => {
				if (response.status === 200) {
					
					togglePopValida();
					setSelectedHabitacion(null);
					obtenerListaHabitacionesByParams(filtroActivo, selectedEstado, filtroEdificio, filtroPlanta,filtroTerminada);
				} else {
					toastGenericErrorLogin();
				}
				
			})
			.catch((err) => {
				toastGenericErrorLogin();
			});;
		
	}
	
	
	
	function togglePopValida() {

		/*if (selectedEstablecimiento != null) {
			setSelectedEstablecimiento(null);
		}*/

		setSeenValidaPopup(!seenValidaPopup);
	}
	
	function togglePop() {

		if (selectedHabitacion != null) {
			setSelectedHabitacion(null);
		}

		setSeen(!seen);
	}

	return (
		<main className={'mainContainerPage'}>
			<section className="principal-container">
			<div className={'container-crearComponente-Habit'}>
				<h1 className={'title-Componente-Habit'}>{t("app.header.enlaces.habitaciones")}</h1>
				
				<div className="container-btns-nuevaHab-download">
					{(userRol === Constants.ROLE_USUARIO_TRABAJADOR && tipoEmpleado != null && tipoEmpleado.id === Constants.TIPO_EMPLEADO_GOBERNANTA) ? null : (
						<div className="container-btnNuevaHabit"><button className={'btn-general'} onClick={togglePop}><FaPlus size="10"/> <p className="txt-btn-nuevoCompt">{t("app.habitacion.nuevaHabitacion")}</p></button></div>)}
						{seen ? <PopUpHabitacion toggle={togglePop}
							loadHabitaciones={obtenerListaHabitaciones}
							loadHabitacionesByParams={obtenerListaHabitacionesByParams}
							limpiarFiltros={limpiarFiltros}
							selectedHabitacion={selectedHabitacion}
							filtroactivo={filtroActivo}
							estadoHabitacion={selectedEstado}
							loadEstados={obtenerEstadoHabitaciones}
							selectedEstablecimiento={establecimiento.id}
							listaEstadosHabitacion={listaEstadosHabitacion}
						/> : null}
						
						{(userRol === Constants.ROLE_USUARIO_ADMINISTRADOR || userRol === Constants.ROLE_USUARIO_ADMIN_CADENA || userRol === Constants.ROLE_USUARIO_GESTOR) ? (
								!selectedFile ? (
									<>
										<input onChange={onChangeFile} multiple={false} ref={fileReference} type='file' hidden/>
										<div className="container-btnNuevaHabit"><button style={{marginLeft: '10px', marginRight: '10px'}} className={'btn-general'} onClick={onClickFile}><MdOutlineFileUpload size={20} /></button></div>
									</>)
									: (<>
											<p className={'selectedFileStyle'}>{selectedFile.name}</p>
											<button className={'button-fileUpload'} onClick={onClickUpload}><MdOutlineFileUpload /></button>
											<button className={'button-cancelFileUpload'} onClick={onClickCancelUpload}><MdCancel /></button>
										</>)
							) : null
						}
						
				</div>
				{seenValidaPopup ? <PopUpValidaHabitacion validaHabitacion={validaHabitacion} toggle={togglePopValida} /> : null}
			</div>
			<Toaster />
			
			{seenConfirmCargarFichero ? <PopUpConfirmCargarFichero
				toggle={togglePopConfirmCargarFichero}
				selectedEstablecimiento={establecimiento.id}
				selectedFichero={selectedFile}
				loadHabitaciones={obtenerListaHabitaciones}
				limpiarFichero={onClickCancelUpload}/>
			: null}
			
			<div className="container-filtro-tabla">
				<div className="container-filtro_Habit">
					<div className="filtersSearchStyle-Habit">
						<div className={'divInputHabit'}>
							<div className={'div_img-filtroInputText'}>
								<IoSearch className="iconSearch" size="20" />
								<input placeholder={t("app.placeholder.buscarEdificio")}
									className={'filtroInputText'}
									type="search"
									value={filtroEdificio}
									onChange={onChangeFiltroEdificio}
								/>
							</div>
						</div>
	
						<div className={'divInputHabit'}>
							<div className={'div_img-filtroInputText'}>
								<IoSearch className="iconSearch" size="20" />
								<input placeholder={t("app.placeholder.buscarPlanta")}
									className={'filtroInputText'}
									type="search"
									value={filtroPlanta}
									onChange={onChangeFiltroPlanta}
								/>
							</div>
						</div>
					</div>
					<div className="container-selects-btn-limpiarFiltro-Habit">
					
						<div className={'filterItemHabit'}>
							<label className={'fieldsetLabel'}>{t("app.habitacion.combinarCamas")}</label>
							<Select
								className={'filtroSelect'}
								value={optionsCombinarCamas.find(e => e.value === filtroCombinarCamas)}
								options={optionsCombinarCamas}
								onChange={option => onChangeFiltroCombinarCamas(option)}
								isSearchable={false}
								styles={colorFiltros}
							/>
						</div>
						
						<div className={'filterItemHabit'}>
							<label className={'fieldsetLabel'}>{t("app.popup.label.activo")}</label>
							<Select
								className={'filtroSelect'}
								defaultValue={optionsActivo[0]}
								value={optionsActivo.find(e => e.value === filtroActivo)}
								options={optionsActivo}
								onChange={option => onChangeFiltroActivo(option)}
								isSearchable={false}
								styles={colorFiltros}
							/>
						</div>
						
						<div className={'filterItemHabit'}>
							<label className={'fieldsetLabel'}>{t("app.popup.label.terminada")}</label>
							<Select
								className={'filtroSelect'}
								defaultValue={optionsTerminada[0]} 
								value={optionsTerminada.find(e => e.value === filtroTerminada)}
								options={optionsTerminada}
								onChange={option => onChangeFiltroTerminada(option)}
								isSearchable={false}
								styles={colorFiltros}
							/>
						</div>
					
						<div className={'filterItemHabit'} >
							<label className={'fieldsetLabel'}>{t("app.habitacion.estado")}</label>
							<Select
								className="filtroSelect"
								placeholder={t("app.poup.label.seleccionarEstadoHabitacion")}
								key={selectedEstado || ''}
								value={listaEstadosHabitacion.find(e => e.id === selectedEstado)}
								onChange={onChangeFiltroEstadoHabitaciones}
								options={listaEstadosHabitacion}
								isSearchable={false}
								formatOptionLabel={estado => (
									<div>
										<span>{estado.estado}</span>
									</div>
								)}
								styles={colorFiltros}
								getOptionValue={getOptionValueEstadoHabitacion}
							/>
						</div>
						
						<div className={'filterItemHabit'}>
						<button className='btn-limpiarFiltro' onClick={() => { limpiarFiltros(); obtenerListaHabitaciones(); }}><FaFilter /> <p className="txt-btn-limpiarFiltro">{t("app.cama.limpiarFiltros")}</p></button>
						</div>
					</div>
					
				</div>
				<div className="containerTabla">
				<Table columns={useColumnsHabitacion(togglePop, togglePopValida, guardarSelectedHabitacion)} data={listaHabitaciones} />
				</div>
			</div>	
			

			
			</section>
		</main>

	);
}

export default Habitacion